<template>
  <div>
    <header class="relative isolate overflow-hidden bg-gradient-to-br from-heroblue-500/75 via-heroblue-600 to-heroblue-900 p-5 sm:p-8 text-white">
      <u-icon
        v-if="headerIcon"
        :name="headerIcon"
        class="pointer-events-none absolute -right-14 -top-14 -z-10 hidden h-72 w-72 text-white/15 sm:block"
      />

      <div class="relative z-10 max-w-3xl">
        <div
          v-if="tag"
          class="mb-5 inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/25 px-3 py-1 font-bold uppercase text-white text-xs/none"
        >
          <u-icon v-if="tagIcon" :name="tagIcon" class="h-5 w-5 text-amber-300" />
          <span class="mt-0.5">{{ tag }}</span>
        </div>

        <h2 v-if="title || $slots.title" class="max-w-full text-2xl font-bold leading-tight sm:max-w-[85%] sm:text-3xl">
          <slot name="title">{{ title }}</slot>
        </h2>

        <p v-if="subtitle" v-html="subtitle" class="mt-4 max-w-full text-base text-white/90 sm:max-w-[85%] sm:text-lg" />
      </div>
    </header>

    <div class="bg-white p-5 sm:p-8">
      <slot />
    </div>
  </div>
</template>

<script setup>
  defineProps({
    tag: String,
    tagIcon: String,
    title: String,
    subtitle: String,
    headerIcon: String
  });
</script>
